import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      // maxWidth: 700,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& h3': {
        marginBottom: theme.spacing(4),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    button: {
      width: '100%',
      padding: theme.spacing(3),

      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'initial',

      border: `1px solid #2121211A`,
      borderRadius: 13,

      '& span:first-child': {
        display: 'flex',
        flexDirection: 'column',

        '& span': {
          maxWidth: '99%',
          marginTop: theme.spacing(2),
        },
      },

      '&.lastButton': {
        '& span:first-child': {
          display: 'flex',
          flexDirection: 'row-reverse',

          '& span': {
            marginTop: 'unset',
            marginRight: theme.spacing(1),
          },
        },
      },
    },
    selectedButton: {
      color: theme.palette.primary.light,
      border: `1px solid ${theme.palette.primary.light}`,
      borderRadius: 13,
    },

    carSectionTitle: {
      marginBottom: theme.spacing(2),
      fontSize: theme.typography.pxToRem(16),
    },
    parkingButton: {
      padding: theme.spacing(0.5, 3),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'initial',
      borderRadius: 17,
    },
    selectedParkingButton: {
      color: theme.palette.primary.contrastText,
      background: theme.palette.primary.light,
    },
  })
);

export default useStyles;
